import React from 'react';
import { Card, CardContent, Typography, Grid, makeStyles } from '@material-ui/core';
import { FacilationButton } from './StyledComponent';
import { useHistory } from 'react-router-dom';


const Image = 'https://i.imgur.com/4LnPljT.jpeg';

const useStyles = makeStyles((theme) => ({
    card: {
        position: 'relative',
        width: '100%',
        margin: 'auto',
        marginTop: theme.spacing(4),
        padding: theme.spacing(2),
        height: 'auto',
        overflow: 'hidden',
    },
    backgroundImage: {
        content: "''",
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: `url(${Image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: '50%',
    },
    backgroundColorLayer: {
        backgroundColor: 'rgba(47, 94, 168, 0.7)',
        width: '100%',
        height: '100%',
        position: 'absolute',
        opacity: '70%',
        top: 0,
        left: 0,
        zIndex: 1
    },
    icon: {
        fontSize: 40,
        color: 'white',
        width: '55px',
        height: '55px',
        zIndex: 2
    },
    title: {
        marginTop: theme.spacing(1),
        textAlign: 'center',
        color: 'white',
        margin: '20px',
        zIndex: 2
    },
    header: {
        position:'relative',
        marginTop: theme.spacing(1),
        textAlign: 'center',
        color: '#fff',
        zIndex: 2,
        fontSize: '24px',
        fontWeight: '600px',
        marginBottom: '12px'
    },
}));

const CitizenFacilitation = () => {
    const classes = useStyles();
    const history = useHistory()
    const homeUrl = '/digit-ui/citizen'
    const inprogressUrl = `${homeUrl}/InProgreeService`
     const iconData = [
        { icon: <img src='https://i.imgur.com/m4QnIck.png' className={classes.icon} />, title: 'Notified Planning/Special Area', action: `${homeUrl}/notifiedArea` },
        { icon: <img src='https://i.imgur.com/0qU2lat.png' className={classes.icon} />, title: 'RTI', action: `${homeUrl}/rti` },
        { icon: <img src='https://i.imgur.com/gAdiHIh.png' className={classes.icon} />, title: 'Regitered Estate Agent', action: `${homeUrl}/registeredAgent` },
        { icon: <img src='https://i.imgur.com/G0ZeisD.png' className={classes.icon} />, title: 'Registered Promoters', action: `${homeUrl}/registeredArchitect` },
        { icon: <img src='https://i.imgur.com/49sZB4N.png' className={classes.icon} />, title: 'Directory of Registered Proffessionals', action: `${homeUrl}/registeredArchitect` },
        { icon: <img src='https://i.imgur.com/64dfsol.png' className={classes.icon} />, title: 'Download Forms', action: inprogressUrl },
        { icon: <img src='https://i.imgur.com/2RI9Vr4.png' className={classes.icon} />, title: 'Public Service Guarantee Act', action: `${homeUrl}/publicActs` },
        { icon: <img src='https://i.imgur.com/Fmq7Rqx.png' className={classes.icon} />, title: 'License and Essentiality Certificates', action: `${homeUrl}/licenseCertificate` },
        { icon: <img src='https://i.imgur.com/cEmJalq.png' className={classes.icon} />, title: 'Planning Permission case', action: `${homeUrl}/registeredArchitect` },
        { icon: <img src='https://i.imgur.com/rLZI0Jx.png' className={classes.icon} />, title: 'Instruction/Orders', action: `${homeUrl}/instructions-orders` },
        { icon: <img src='https://i.imgur.com/TqMvq5G.png' className={classes.icon} />, title: 'Area Locator', action: inprogressUrl },
        { icon: <img src='https://i.imgur.com/eDXNkGq.png' className={classes.icon} />, title: 'Unauthorized Construction', action: inprogressUrl },
    ];

    return (
        <Card className={classes.card}>
        
            <div className={classes.backgroundImage}></div>
            <div className={classes.backgroundColorLayer}></div>
            <CardContent>
                <div className={classes.header}>
                    Citizen Facilitation 
                </div>
                <Grid container spacing={2} justifyContent="center" alignItems='center' alignContent='center'>
                    {iconData.map((item, index) => (
                        <Grid item key={index} xs={6} sm={4} md={3} lg={2}>
                            <FacilationButton onClick={() => history.push(item.action)}>
                                {item.icon}
                                <Typography variant="subtitle1" className={classes.title}>
                                    {item.title}
                                </Typography>
                            </FacilationButton>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </Card>);
};

export default CitizenFacilitation;
